import { useSelector } from "react-redux";
import { useGetTodosQuery } from "../features/api/apiSlice";
import Todo from "./Todo";

export default function TodoList() {
  const { data: todos, isLoading, isError, error } = useGetTodosQuery();
  const { status, colors } = useSelector((state) => state.filter);

  const filterByStatus = (todo) => {
    if (status === "All") {
      return true;
    }
    if (status === "Incomplete") {
      return todo.completed === false;
    }
    if (status === "Complete") {
      return todo.completed === true;
    }
  };
  const filterByColor = (todo) => {
    if (colors.length === 0) {
      return true;
    } else {
      let valid = false;
      colors.map((color) => {
        if (todo.color === color) {
          valid = true;
        }
      });
      return valid;
    }
  };
  if (isLoading) {
    return "Loading...";
  }
  if (error) {
    return <div>{error}</div>;
  }
  return (
    <div className="mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
      {todos?.length === 0 && <p>No tasks added.</p>}
      {todos
        ?.filter((todo) => filterByStatus(todo))
        .filter((todo) => filterByColor(todo))
        .map((todo) => (
          <Todo todo={todo} key={todo.id} />
        ))}
    </div>
  );
}
